var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensiones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 71",
    width: 320,
    height: 71,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Academico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320.24 69.72h-320l3.14-69.72 316.86 4.56v65.16z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e8bb7e } \n\t\t.s1 { fill: #f2c38c } \n\t\t.s2 { fill: #f7d19a } \n\t\t.s3 { fill: #d8a568 } \n\t\t.s4 { opacity: .3;mix-blend-mode: multiply;fill: #212121 } \n\t\t.s5 { fill: #414042 } \n\t\t.s6 { fill: #353535 } \n\t\t.s7 { fill: #6d6e71 } \n\t\t.s8 { fill: #542e09 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m320.2 67.4l-320 2.3 3.2-69.7 316.8 4.6v62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m320 42l-319-3 2.4-39 316.8 4.6-0.2 37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m3.4 0v1.4l316.8 3.2v-1.1l-316.8-3.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m322.4 3.8l-9.3 3.4-16.8 0.3-19.6-1.9-12 0.2-17.4-2-27.5 2.6-51.6-1.4-14.2 0.3-13.8 2.4-23.2-1.9-15.3 2.4-2.7-0.9-9.9-3.3-11.5 0.2-9.3 2.4-17.7 0.2-11.2-2-12 0.2-25.2 4.8 28-1.6 13.3 1.2 26.7 1.5 12.3-4.9 27.4 4.3 7.2-3.4 16.1 3 16.6-0.2 6.5-2 11.9-1.6 12.5 3.1 12-0.2 19.8-0.3 12.7-0.2 12.4-0.1 10.2-2.1 9.8 1.7 7.1-0.1 7.6-0.1 12.4-0.2 11.2 2.1 13.3-0.3 7.1-0.1 6.1-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-6.8 21.4l14.1-3.4 25.8-0.3 29.8 2 18.3-0.2 26.5 2 42-2.6 78.7 1.5 21.6-0.2 21.2-2.4 35.3 1.9 23.4-2.4 4.1 0.9 15 3.3 17.6-0.2 14.2-2.3 27.1-0.2 17 2 18.3-0.2 38.5-4.7-42.7 1.5-20.3-1.2-40.7-1.5-18.9 4.8-41.6-4.3-11.1 3.4-24.5-3.1-25.4 0.3-9.9 1.9-18.2 1.6-18.9-3.1-18.4 0.1-30.2 0.3-19.4 0.2-19 0.2-15.5 2-14.9-1.8-10.9 0.1-11.5 0.1-19 0.2-17-2-20.3 0.1-10.8 0.1-9.4 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-135 25.1l14.2 3.4 25.7 0.2 29.9-2 18.3 0.1 26.4-2 42 2.5 78.7-1.6 21.6 0.2 21.3 2.3 35.2-1.9 23.4 2.4 4.1-0.9 15-3.4 17.6 0.2 14.2 2.3 27.1 0.2 17-2.1 18.3 0.1 38.5 4.7-42.6-1.4-20.4 1.2-40.7 1.6-18.9-4.8-41.6 4.4-11-3.4-24.6 3.1-25.3-0.2-10-1.9-18.2-1.6-18.9 3.2-18.4-0.2-30.1-0.2-19.5-0.1-18.9-0.2-15.6-2-14.9 1.8-10.9-0.1-11.5-0.1-19-0.1-16.9 2-20.4-0.1-10.8-0.1-9.4-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m322.4 66l-9.3-3.5-16.8-0.2-19.6 1.9-12-0.2-17.4 1.9-27.5-2.6-51.6 1.4-14.2-0.2-13.8-2.4-23.2 1.8-15.3-2.4-2.7 0.9-9.9 3.3-11.5-0.2-9.3-2.3-17.7-0.3-11.2 2-12-0.2-25.2-4.7 28 1.5 13.3-1.2 26.7-1.5 12.3 4.9 27.4-4.3 7.2 3.4 16.1-3 16.6 0.2 6.5 2 11.9 1.6 12.5-3.1 12 0.2 19.8 0.3 12.7 0.2 12.4 0.2 10.2 2 9.8-1.7 7.1 0.1 7.6 0.1 12.4 0.2 11.2-2 13.3 0.2 7.1 0.1 6.1 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-6.8 48.4l14.1 3.4 25.8 0.2 29.8-1.9 18.3 0.1 26.5-1.9 42 2.5 78.7-1.4 21.6 0.1 21.2 2.4 35.3-1.9 23.4 2.4 4.1-0.9 15-3.3 17.6 0.2 14.2 2.3 27.1 0.3 17-2.1 18.3 0.2 38.5 4.7-42.7-1.5-20.3 1.2-40.7 1.5-18.9-4.8-41.6 4.3-11.1-3.4-24.5 3.1-25.4-0.2-9.9-2-18.2-1.6-18.9 3.1-18.4-0.1-30.2-0.3-19.4-0.1-19-0.2-15.5-2-14.9 1.7-10.9-0.1-11.5-0.1-19-0.2-17 2.1-20.3-0.2-10.8-0.1-9.4-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-19.2 44.6l14.2-3.3 25.7-0.2 29.9 1.9 18.3-0.1 26.4 2 42-2.5 78.7 1.6 21.6-0.2 21.3-2.3 35.2 1.9 23.5-2.4 4 1 15 3.3 17.6-0.2 14.2-2.2 27.1-0.2 17 2 18.3-0.1 38.5-4.7-42.6 1.4-20.4-1.2-40.7-1.6-18.9 4.8-41.6-4.3-11 3.3-24.6-3.1-25.3 0.2-10 2-18.2 1.5-18.9-3.1-18.3 0.1-30.2 0.2-19.5 0.2-18.9 0.1-15.6 2-14.9-1.8-10.9 0.1-11.5 0.1-19 0.1-16.9-2-20.4 0.1-10.8 0.1-9.4 5.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m0.2 69.7l320-2.3v1.2l-320 2.4v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m16.9 8.9c0 2.4-1.9 5-4.3 5-2.4 0-4.3-2.6-4.3-5 0-2.4 1.9-4.3 4.3-4.3 2.4 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m12.6 13.2c-2.4 0-4.3-1.9-4.3-4.3 0-2.4 1.9-4.3 4.3-4.3 2.4 0 4.3 1.9 4.3 4.3 0 2.4-1.9 4.3-4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m12.7 10.9c-1.7 0-2.7-0.9-3.2-2 0 1.7 1.4 3.5 3.1 3.5 1.7 0 3.1-1.8 3.1-3.5-0.4 1.2-1.5 2-3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m12.6 12c-1.7 0-3.1-1.4-3.1-3.1 0-1.8 1.4-3.1 3.1-3.1 1.7 0 3.1 1.3 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m14.8 6.7q0.4 0.6 0.4 1.4c0 1.5-1.1 2.7-2.6 2.7-1.5 0-2.7-1.2-2.7-2.7q0-0.8 0.5-1.4c-0.6 0.6-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-0.9-0.3-1.6-0.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m314.3 12.9c0 2.4-2 5-4.3 5-2.4 0-4.4-2.6-4.4-5 0-2.4 2-4.3 4.4-4.3 2.3 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m310 17.2c-2.4 0-4.4-1.9-4.4-4.3 0-2.4 2-4.3 4.4-4.3 2.3 0 4.3 1.9 4.3 4.3 0 2.4-2 4.3-4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m310 14.9c-1.6 0-2.6-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.1 3.5 1.8 0 3.2-1.8 3.2-3.5-0.5 1.2-1.5 2-3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m310 16c-1.8 0-3.2-1.4-3.2-3.1 0-1.8 1.4-3.1 3.2-3.1 1.7 0 3.1 1.3 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m312.2 10.7q0.4 0.6 0.4 1.4c0 1.5-1.2 2.7-2.6 2.7-1.5 0-2.7-1.2-2.7-2.7q0-0.8 0.4-1.4c-0.5 0.6-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.2 3.1 1.7 0 3.1-1.4 3.1-3.1 0-0.9-0.3-1.6-0.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m314.3 59.6c0 2.4-2 5-4.3 5-2.4 0-4.4-2.6-4.4-4.9 0-2.4 2-4.4 4.4-4.4 2.3 0 4.3 2 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m310 64c-2.4 0-4.4-2-4.4-4.4 0-2.3 2-4.3 4.4-4.3 2.3 0 4.3 2 4.3 4.3 0 2.4-2 4.4-4.3 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m310 61.7c-1.6 0-2.6-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.1 3.5 1.8 0 3.2-1.8 3.2-3.5-0.5 1.1-1.5 2-3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m310 62.8c-1.8 0-3.2-1.4-3.2-3.1 0-1.8 1.4-3.2 3.2-3.2 1.7 0 3.1 1.4 3.1 3.2 0 1.7-1.4 3.1-3.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m312.2 57.5q0.4 0.6 0.4 1.4c0 1.5-1.2 2.7-2.6 2.7-1.5 0-2.7-1.2-2.7-2.7q0-0.8 0.4-1.4c-0.5 0.5-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.2 3.1 1.7 0 3.1-1.4 3.1-3.1 0-0.9-0.4-1.7-0.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m13.8 60c0 2.4-2 5-4.3 5-2.4 0-4.3-2.6-4.3-5 0-2.4 1.9-4.3 4.3-4.3 2.3 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m9.5 64.3c-2.4 0-4.3-1.9-4.3-4.3 0-2.4 1.9-4.3 4.3-4.3 2.3 0 4.3 1.9 4.3 4.3 0 2.4-2 4.3-4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m9.5 62c-1.6 0-2.6-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.2 3.5 1.7 0 3.1-1.8 3.1-3.5-0.5 1.2-1.5 2-3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m9.5 63.1c-1.8 0-3.2-1.4-3.2-3.1 0-1.8 1.4-3.2 3.2-3.2 1.7 0 3.1 1.4 3.1 3.2 0 1.7-1.4 3.1-3.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m11.7 57.8q0.4 0.6 0.4 1.4c0 1.5-1.2 2.7-2.6 2.7-1.5 0-2.7-1.2-2.7-2.7q0-0.8 0.4-1.4c-0.5 0.6-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.2 3.1 1.7 0 3.1-1.4 3.1-3.1 0-0.9-0.4-1.6-0.9-2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "DIMENSIONES",
    className: "s8",
    "aria-label": "DIMENSIONES",
    d: "m51.9 22.6h-8.6v24.4h8.6c7.8 0 12.9-4.8 12.9-12.2 0-7.4-5.1-12.2-12.9-12.2zm-3.7 20.2v-16.1h3.5c5.1 0 8 3 8 8.1 0 5.1-2.9 8-8 8zm20.2 4.2h4.9v-24.4h-4.9zm9.7 0h4.9v-15.9l6.6 15.9h3.7l6.6-15.9v15.9h4.9v-24.5h-5.6l-7.7 18.2-7.8-18.2h-5.6zm45.7-24.4h-14.2v24.4h14.2v-4h-9.3v-6.4h8.2v-3.9h-8.2v-6.1h9.3zm20.4 0v16.8l-11.1-16.8h-4.9v24.4h4.9v-16.7l11.1 16.7h4.9v-24.4zm26.8 17.4c0-8.7-12.5-5.9-12.5-10.8 0-2 1.4-3 3.3-2.9 2.1 0 3.4 1.3 3.5 2.9h5.4c-0.3-4.4-3.7-7-8.7-7-5.1 0-8.6 2.7-8.6 7.1-0.1 8.9 12.5 5.7 12.5 11 0 1.7-1.3 2.9-3.6 2.9-2.3 0-3.6-1.2-3.7-3.2h-5.3c0.1 4.6 4 7.3 9.1 7.3 5.5 0 8.6-3.5 8.6-7.3zm4.2 7h4.9v-24.4h-4.9zm33.6-12.3c0-7.3-5.5-12.5-12.5-12.5-6.9 0-12.5 5.2-12.5 12.5 0 7.4 5.6 12.5 12.5 12.5 6.9 0 12.5-5.1 12.5-12.5zm-20 0c0-5 3.1-8.1 7.5-8.1 4.4 0 7.5 3.1 7.5 8.1 0 5-3.1 8.2-7.5 8.2-4.4 0-7.5-3.2-7.5-8.2zm39.6-12.2v16.8l-11-16.8h-4.9v24.5h4.9v-16.8l11 16.8h4.9v-24.5zm24 0h-14.2v24.5h14.2v-4h-9.3v-6.5h8.2v-3.9h-8.2v-6.1h9.3zm21.5 17.4c0-8.6-12.6-5.9-12.6-10.8 0-2 1.5-2.9 3.4-2.8 2.1 0 3.4 1.3 3.5 2.9h5.4c-0.3-4.4-3.7-7-8.8-7-5 0-8.6 2.7-8.6 7.1 0 8.8 12.6 5.6 12.6 10.9 0 1.8-1.4 3-3.7 3-2.2 0-3.5-1.3-3.7-3.2h-5.2c0 4.6 4 7.2 9 7.2 5.6 0 8.7-3.4 8.7-7.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensiones);
export default __webpack_public_path__ + "static/media/Dimensiones.b1049b2ddb7a006efdbcc84ab8cbcfed.svg";
export { ForwardRef as ReactComponent };